module.exports = __webpack_public_path__ + "assets/67b48f67e99a1489d1bc7b58565a360f.svg";